import { SovosButton, SovosCircularProgress } from "mosaic-react";
import React from "react";
import styles from "./DownloadButton.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { Download } from "mosaic-react-icons";

export const DownloadButton = (props) => {
    const { i18n, locale, download } = useGlobalValue();
    const { downloading, downloadableQueries, label } = props;
    return (
        <SovosButton
            key="defaultButton"
            className={`${styles["action-button"]}`}
            onClick={() => download && download(downloadableQueries, locale)}
            startIcon={!downloading && <Download />}
        >
            {downloading ? <SovosCircularProgress thickness={10} size={"1rem"} /> : i18n`${label}`}
        </SovosButton>
    );
};
